import { LoaderMessage } from "../../../components/loaderMessage/loaderMessage";

const Loader = () => {
  return (
    <div className="loader-conatiner flex h-full w-full items-center justify-center">
      <LoaderMessage message="Loading draft submissions details..." />
    </div>
  );
};

export default Loader;
